import { darkColors, secondaryColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledAlternativePath = styled.div`
  background: linear-gradient(179.2deg, #223654 72.84%, #182337 145.61%, #151c2b 188.82%);
  padding: 3.2rem;
  border-radius: 0.6rem;
  margin-top: 2.4rem;
  margin-bottom: 4rem;
`;

export const StyledInfoMessage = styled.div`
  background-color: ${darkColors.info.light};
  padding: 1.8rem;
  border-radius: ${({ theme }) => theme.radius.small};
  margin-bottom: 2.4rem;
  display: flex;
  align-items: center;
  color: ${secondaryColors.grey[100]};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
`;

export const StyledAlternativePathDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.sizes.sm}) {
    flex-direction: column;
  }
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    align-items: flex-start;
  }
`;

export const StyledAlternativePathImage = styled.div`
  img {
    width: 100%;
    border-radius: ${({ theme }) => theme.radius.small};
    padding-right: 2.4rem;
    @media (max-width: ${({ theme }) => theme.sizes.sm}) {
      padding-right: 0;
      padding-bottom: 2.4rem;
    }
  }
`;

export const StyledAlternativePathDifficulty = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 1rem;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
    align-items: flex-start;
  }

  h4 {
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
    font-size: 2rem;
    color: ${secondaryColors.grey[100]};
    margin-bottom: 0;
    padding-right: 1rem;
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      padding-bottom: 1rem;
    }
  }
`;

export const StyledAlternativePathSummary = styled.p`
  color: ${secondaryColors.grey[200]};
  padding-bottom: 2.4rem;
`;
